import React, { Fragment, useState, useEffect } from 'react';
import moment from 'moment';

import LoanDetails from './LoanDetails';
import PopUp from '../../common/components/PopUp/PopUp';
import numberFormat from '../../common/constants/NumberFormat';
import { getCreditReport } from '../../common/constants/api';
import { setLocalStorage } from '../../common/utils/localstorage-utils';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import ProgressBar from '../../../../consumer-ui/src/common/components/CustomProgressBar/index';

import experianColor from '../../../../consumer-ui/src/images/experian-logo.png';
import buildingblue from '../../images/icons/buildingblue.svg';
import checked from '../../images/icons/checkbox_ok.svg';
import Style from './CreditReport.module.css';

const CreditReport = ({ getcreditReportApi }) => {
  const { basic_det } = Style;
  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState(false);
  const [modaldata, setModalData] = useState([]);
  const [dataSumm, setDataSumm] = useState('');
  const [dataArr, setDataArr] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isGetOver, setGetOver] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  function openDetails(id, data) {
    if (id >= 0) {
      setShowModal(true);
      setModalData(data);
    } else {
      setShow(false);
    }
  }

  // get credit Report
  useEffect(() => {
    let getCreditReportFun = getCreditReport;

    if (typeof getcreditReportApi == 'function') {
      getCreditReportFun = getcreditReportApi;
    }
    getCreditReportFun()
      .then(res => {
        setDataSumm(res?.creditReportSummary);
        setLocalStorage(
          'creditScore',
          res?.creditReportSummary?.creditScore || -1
        );
        setDataArr(res?.creditAccounts);
        setIsCompleted(true);
        setTimeout(() => {
          setGetOver(true);
        }, 200);
      })
      .catch(err => {
        setIsError(true);
        setLocalStorage('creditScore', -1);
        setTimeout(() => {
          setGetOver(true);
        }, 300);
      });
  }, []);
  const DisplayCreditSummary = creditNumber => {
    let creditScoreGroup = 'Excellent';
    const findCreditScoreGroup = () => {
      const creditScore = parseInt(creditNumber);
      if (creditScore < 580)
        creditScoreGroup = <span className="text-red-700">Very Poor</span>;
      else if (creditScore < 670 && creditScore >= 580)
        creditScoreGroup = (
          <span className="text-orange-1200 text-2xl ">Poor</span>
        );
      else if (creditScore < 740 && creditScore >= 670)
        creditScoreGroup = (
          <span className="text-yellow-100 text-2xl">Fair</span>
        );
      else if (creditScore < 800 && creditScore >= 740)
        creditScoreGroup = (
          <span className="text-green-dimgreen">Very Good </span>
        );
      else if (creditScore >= 800)
        creditScoreGroup = <span className="text-green-1500">Exceptional</span>;
    };
    try {
      parseInt(creditNumber);
      findCreditScoreGroup();
    } catch {
      creditScoreGroup = <span className="text-black-0">-----</span>;
    }
    return creditScoreGroup;
  };

  if (!isGetOver) {
    return <ProgressBar completed={isCompleted} />;
  } else if (isError)
    return (
      <div className="w-full h-full min-h-screen overflow-auto scrolling-auto ">
        <div
          className={
            'w-11/12 md:mb-5 max-w-2xl  md:max-w-none md:min-w-150  rounded-md shadow-none md:shadow-md  md:bg-white mx-auto mt-0 md:mt-8 font-roboto font-medium box-border overflow-auto p-5 md:p-8 md:pb-0 h-screen md:h-auto'
          }
          style={{
            minHeight: '500px'
          }}
        >
          <div className=" w-full mt-20 text-black-1003 text-base font-medium text-center mx-auto">
            No Data Available. .
          </div>
        </div>
      </div>
    );
  else
    return (
      <Fragment>
        <div className="w-auto md:min-w-70v bg-white py-8 md:py-2 px-5 md:mx-5 my-10">
          <div
            className="w-full block rounded-md max-w-3xl my-3 shadow-md p-2 float-center mx-auto mb-4"
            style={{ backgroundColor: '#E0FCFF', color: 'black' }}
          >
            <div className="xl:flex flex-wrap">
              <div className="xl:w-5/12 w-full">
                <div className="flex px-2 py-2">
                  <div
                    className="block text-left"
                    style={{ width: 'fit-content' }}
                  >
                    <p className="font-roboto font-normal text-black mr-auto text-sm">
                      Credit Score
                    </p>
                    <p
                      className="font-roboto font-bold text-xl mr-auto"
                      style={{ color: '#4A4A4A' }}
                    >
                      {dataSumm?.creditScore || 0}/{' '}
                      <span className="text-sm font-normal">900</span>
                    </p>
                  </div>

                  <div
                    className="ml-auto text-left mr-3 text-center mt-auto py-1"
                    style={{ width: 'fit-content' }}
                  >
                    <p className="font-roboto font-semibold text-green-flagGreen text-lg md:pr-4">
                      {DisplayCreditSummary(dataSumm?.creditScore)}
                    </p>
                  </div>
                </div>

                <div className="flex items-baseline">
                  <p className="font-roboto md:ml-10 ml-auto text-center font-normal text-md text-black ">
                    Powered by
                  </p>
                  <div className={`mr-0 ml-4 mr-2 items-left`}>
                    <img src={experianColor} width="70px" />
                  </div>
                </div>
                <div className="flex px-2 mt-2 items-baseline ">
                  <p className="text-grey-1003 font-roboto font-normal md:ml-0 ml-auto">
                    Last Updated on :
                  </p>
                  <p className="text-black-400 font-roboto text-xs md:pl-4 ">
                    {dataSumm?.reportDate
                      ? moment(dataSumm?.reportDate).format('Do MMM YYYY')
                      : 'NA'}
                  </p>
                </div>
              </div>
              <div className="xl:w-7/12 w-full xl:pl-40">
                <div className="w-full float-left xl:hidden my-5">
                  <hr
                    className="border-solid border xl:hidden"
                    style={{ borderColor: '#8597A8' }}
                  />
                </div>
                <div className="py-2">
                  <p className="text-green-800 text-sm font-medium">
                    Tips to Improve your Credit Score
                  </p>
                </div>
                <div className="flex  py-2 text-xs text-black-400">
                  <span className="px-1 ">
                    <img src={checked} alt="checked" />
                  </span>
                  <span className="">
                    Spend around 30% of your Credit Limit
                  </span>
                </div>
                <div className="flex  py-2 text-xs text-black-400">
                  <span className="px-1">
                    <img src={checked} alt="checke" />
                  </span>
                  <span className="">Keep your oldest Credit Card Active</span>
                </div>
                <div className="flex  py-2 text-xs text-black-400">
                  <span className="px-1">
                    <img src={checked} alt="checke" />
                  </span>
                  <span className="">
                    Don’t apply too many Loan or Credit card at once
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            className="lg:w-10/12 md:w-10/12 mx-auto my-4"
            style={{ backgroundColor: '#FCFCFC', borderRadius: '6px' }}
          >
            <h1 className="md:px-6 px-2 text-left pt-6 text-black-400 font-roboto text-xl">
              Basic Information
            </h1>
            <div className={`xl:flex flex-wrap `}>
              <div className={`block px-6 xl:w-4/12 w-full`}>
                <div className={`${basic_det} md:my-10 my-4`}>
                  <p className="text-grey-1003 font-roboto font-normal text-xs text-left">
                    Full Name
                  </p>
                  <p className="text-black-400 font-roboto text-sm">
                    :
                    {dataSumm?.consumerDetails?.name
                      ? ` ${dataSumm?.consumerDetails?.name?.firstName ||
                          ''} ` +
                        `${dataSumm?.consumerDetails?.name?.lastName || ''}`
                      : 'NA'}
                  </p>
                </div>
                <div className={`${basic_det} md:my-10 my-4`}>
                  <p className="text-grey-1003 font-roboto font-normal text-xs">
                    PAN Card Number
                  </p>
                  <p className="text-black-400 font-roboto text-sm ">
                    : {dataSumm?.consumerDetails?.pan || 'NA'}
                  </p>
                </div>
              </div>

              <div className={`block px-6 xl:w-4/12 w-full`}>
                <div className={`${basic_det} md:my-10 my-4`}>
                  <p className="text-grey-1003 font-roboto font-normal text-xs">
                    Gender
                  </p>
                  <p className="text-black-400 font-roboto text-sm">
                    : {dataSumm?.consumerDetails?.gender || 'NA'}
                  </p>
                </div>
                <div className={`${basic_det} md:my-10 my-4`}>
                  <p className="text-grey-1003  font-roboto font-normal text-xs">
                    Mobile Number
                  </p>
                  <p className="text-black-400 font-roboto text-sm">
                    : {dataSumm?.consumerDetails?.phoneNumber || 'NA'}
                  </p>
                </div>
              </div>

              <div className={`block px-6 xl:w-4/12 w-full`}>
                <div className={`${basic_det} md:my-10 my-4`}>
                  <p className="text-grey-1003 font-roboto font-normal text-xs">
                    DOB
                  </p>
                  <p className="text-black-400 font-roboto text-sm">
                    :
                    {dataSumm?.consumerDetails?.dob
                      ? moment(dataSumm?.consumerDetails?.dob).format(
                          'Do MMM YYYY'
                        )
                      : 'NA'}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="lg:w-10/12 md:w-10/12 mx-auto my-4"
            style={{ backgroundColor: '#FCFCFC', borderRadius: '6px' }}
          >
            <h1
              className="text-xl px-6 font-roboto text-left pt-6"
              style={{ color: '#29333B' }}
            >
              Credit Account summary
            </h1>
            <div className={`flex flex-wrap  text-center`}>
              <div className={`block px-6 xl:w-3/12  w-6/12 text-left`}>
                <div className="md:my-10 my-4">
                  <p className="text-grey-1003 font-roboto font-normal text-sm ">
                    Total Accounts
                  </p>
                  <p className="text-black-400 font-roboto text-lg  ">
                    {dataSumm?.creditAccountSummary?.totalAccounts || 0}
                  </p>
                </div>
              </div>

              <div className={`block px-6 xl:w-3/12 w-6/12 text-left`}>
                <div className=" md:my-10 my-4">
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    Active Accounts
                  </p>
                  <p className="text-black-400 font-roboto text-lg">
                    {dataSumm?.creditAccountSummary?.activeAccounts || 0}
                  </p>
                </div>
              </div>

              <div className={`block px-6 xl:w-3/12 w-6/12 text-left`}>
                <div className="md:my-10 my-4">
                  <p className="text-grey-1003  font-roboto font-normal text-sm">
                    Closed Accounts
                  </p>
                  <p className="text-black-400 font-roboto text-lg">
                    {dataSumm?.creditAccountSummary?.closedAccounts || 0}
                  </p>
                </div>
              </div>
              <div className={`block px-6 xl:w-3/12 w-6/12 text-left`}>
                <div className=" md:my-10 my-4">
                  <p className="text-grey-1003  font-roboto font-normal text-sm">
                    Settled Accounts
                  </p>
                  <p className="text-black-400 font-roboto text-lg">
                    {dataSumm?.creditAccountSummary?.settled || 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="lg:w-10/12 md:w-10/12 mx-auto my-4"
            style={{ backgroundColor: '#FCFCFC', borderRadius: '6px' }}
          >
            <h1
              className="text-xl px-6 font-roboto text-left pt-6"
              style={{ color: '#29333B' }}
            >
              Total Balance Summary
            </h1>
            <div className={`flex flex-wrap `}>
              <div className={`block px-6 xl:w-3/12 w-6/12`}>
                <div className="md:my-10 my-4">
                  <p className="text-grey-1003 font-roboto font-normal text-sm text-left">
                    Total Current Balance
                  </p>
                  <p className="text-black-400 font-roboto lg:text-lg text-sm ">
                    {dataSumm?.currentBalanceSummary?.totalCurrentBalance
                      ? `₹${numberFormat(
                          dataSumm?.currentBalanceSummary?.totalCurrentBalance
                        )}`
                      : 0}
                  </p>
                </div>
              </div>

              <div className={`block px-6 xl:w-3/12 w-6/12`}>
                <div className=" md:my-10 my-4">
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    Secure Account Balance
                  </p>
                  <p className="text-black-400 font-roboto lg:text-lg text-sm">
                    {dataSumm?.currentBalanceSummary?.securedAccountBalance
                      ? `₹${numberFormat(
                          dataSumm?.currentBalanceSummary?.securedAccountBalance
                        )}`
                      : 0}
                  </p>
                </div>
              </div>

              <div className={`block px-6 xl:w-3/12 w-6/12`}>
                <div className="md:my-10 my-4">
                  <p className="text-grey-1003  font-roboto font-normal text-sm">
                    Unsecured Account Balance
                  </p>
                  <p className="text-black-400 font-roboto lg:text-lg text-sm">
                    {dataSumm?.currentBalanceSummary?.unsecuredAccountBalance
                      ? `₹${numberFormat(
                          dataSumm?.currentBalanceSummary
                            ?.unsecuredAccountBalance
                        )}`
                      : 0}
                  </p>
                </div>
              </div>
              <div className={`block px-6 xl:w-3/12 w-6/12`}>
                <div className=" md:my-10 my-4">
                  <p className="text-grey-1003  font-roboto font-normal text-sm">
                    Settled Balance
                  </p>
                  <p className="text-black-400 font-roboto lg:text-lg text-sm">
                    {dataSumm?.currentBalanceSummary?.settled
                      ? `₹${numberFormat(
                          dataSumm?.currentBalanceSummary?.settled
                        )}`
                      : 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="lg:w-10/12 md:w-10/12 mx-auto my-4"
            style={{ backgroundColor: '#FCFCFC', borderRadius: '6px' }}
          >
            <h1
              className="text-xl px-6 font-roboto text-left pt-6"
              style={{ color: '#29333B' }}
            >
              Total Enquiry Summary
            </h1>
            <div className={`flex flex-wrap `}>
              <div className={`block px-6 xl:w-3/12 w-6/12`}>
                <div className="md:my-10 my-4">
                  <p className="text-grey-1003 font-roboto font-normal text-sm text-left">
                    Last 7 days
                  </p>
                  <p className="text-black-400 font-roboto text-lg ">
                    {dataSumm?.creditEnquirySummary?.last7Days || 0}
                  </p>
                </div>
              </div>

              <div className={`block px-6 xl:w-3/12 w-6/12`}>
                <div className=" md:my-10 my-4">
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    Last 30 days
                  </p>
                  <p className="text-black-400 font-roboto text-lg">
                    {dataSumm?.creditEnquirySummary?.last30Days || 0}
                  </p>
                </div>
              </div>

              <div className={`block px-6 xl:w-3/12 w-6/12`}>
                <div className="md:my-10 my-4">
                  <p className="text-grey-1003  font-roboto font-normal text-sm">
                    Last 90 days
                  </p>
                  <p className="text-black-400 font-roboto text-lg">
                    {dataSumm?.creditEnquirySummary?.last90Days || 0}
                  </p>
                </div>
              </div>
              <div className={`block px-6 xl:w-3/12 w-6/12`}>
                <div className=" md:my-10 my-4">
                  <p className="text-grey-1003  font-roboto font-normal text-sm">
                    Last 180 days
                  </p>
                  <p className="text-black-400 font-roboto text-lg">
                    {dataSumm?.creditEnquirySummary?.last180Days || 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:w-10/12 xl:w-10/12 mx-auto my-4">
            <h1
              className="text-xl mx-6 font-roboto text-left pt-6"
              style={{ color: '#1BACB8' }}
            >
              All Loan Summary
            </h1>
          </div>
          <Fragment>
            {dataArr?.map((each, index) => (
              <div
                className="lg:w-10/12 md:w-10/12 mx-auto mb-2 clickablerow cursor-pointer"
                style={{ backgroundColor: '#FCFCFC', borderRadius: '6px' }}
                key={index}
                onClick={() => {
                  openDetails(index, each);
                }}
              >
                <div className="md:flex flex-wrap  mx-4 pt-4 items-baseline">
                  <div className={`xl:w-4/12 w-full `}>
                    <div className="flex items-center py-2 my-1 px-1">
                      <div className={`mr-1 items-center`}>
                        <img src={buildingblue} />
                      </div>
                      <div className="w-full items-center">
                        <p className="font-roboto font-normal text-xs  text-black">
                          {each?.insitution}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className={`xl:w-5/12 w-full md:ml-auto`}>
                    <div className="flex items-center mr-3 text-center">
                      <button
                        className="py-2 px-3 bg-green-900 rounded w-46 text-xs font-bold"
                        style={{
                          backgroundColor: '#E3F3F4',
                          color: '#1BACB8'
                        }}
                      >
                        {each?.type || 'NA'}
                      </button>
                      <div className="md:flex pl-6  ml-auto items-baseline">
                        <p className="text-grey-1003 font-roboto text-sm md:py-2">
                          Date of Open
                        </p>
                        <p className="text-black-400 font-roboto text-xs md:pl-4 md:py-2">
                          {each?.dateOpened
                            ? moment(each?.dateOpened).format('Do MMM YYYY')
                            : 'NA'}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`flex flex-wrap `}>
                  <div className={`block px-6 xl:w-3/12 w-6/12`}>
                    <div className="md:my-10 my-4">
                      <p className="text-grey-1003 font-roboto font-normal text-sm text-left">
                        Account Number
                      </p>
                      <p className="text-black-400 font-roboto lg:text-lg text-sm">
                        {each?.accountNumber || 'NA'}
                      </p>
                    </div>
                  </div>
                  <div className={`block px-6 xl:w-3/12 w-6/12`}>
                    <div className=" md:my-10 my-4">
                      <p className="text-grey-1003 font-roboto font-normal text-sm">
                        Sanction Loan Amount
                      </p>
                      <p className="text-black-400 font-roboto lg:text-lg text-sm">
                        {each?.sanctionedAmount
                          ? `₹ ${numberFormat(each?.sanctionedAmount)}`
                          : 0}
                      </p>
                    </div>
                  </div>
                  <div className={`block px-6 xl:w-3/12 w-6/12`}>
                    <div className="md:my-10 my-4">
                      <p className="text-grey-1003  font-roboto font-normal text-sm">
                        On time Payment
                      </p>
                      <p className="text-black-400 font-roboto lg:text-lg text-sm">
                        {each?.dateReported
                          ? moment(each?.dateReported).format('Do MMM YYYY')
                          : 'NA'}
                      </p>
                    </div>
                  </div>
                  <div className={`block px-6 xl:w-3/12 w-6/12`}>
                    <div className=" md:my-10 my-4">
                      <p className="text-grey-1003  font-roboto font-normal text-sm">
                        Status
                      </p>
                      <p className="text-green-flagGreen font-roboto lg:text-lg text-sm break-words">
                        {each?.status || 'NA'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Fragment>
        </div>
        <div className="text-center mb-4 py-6">
          <p className="text-orange-600 mx-auto">
            Having trouble ? Contact us at info@fincity.com
          </p>
        </div>

        <LoanDetails
          showModal={showModal}
          setShowModal={setShowModal}
          modaldata={modaldata}
        />
      </Fragment>
    );
};

export default withErrorHandler(CreditReport);
